<template>
    <div class="tw-animate-pulse tw-group tw-relative tw-grid tw-grid-rows-5 tw-grid-cols-5 tw-gap-1 tw-w-[227px] lg:tw-w-1/5 2xl:tw-w-1/6 tw-shrink-0 tw-pr-[6px] xl:tw-pr-[12px] 2xl:tw-pr-[16px]">
        <!-- Thumbnail -->
        <div class="tw-relative tw-overflow-hidden tw-bg-ui-skeleton tw-aspect-square tw-row-span-5 tw-col-span-5 tw-rounded-lg tw-h-auto"></div>
        <!-- Text-->
        <div class="playlist-info-link tw-flex tw-w-full tw-text-[#0D0D0D] dark:tw-text-white tw-group tw-col-span-4">
            <div class="tw-w-full">
                <div class="tw-w-full tw-h-[23px] tw-flex tw-mt-1 tw-bg-ui-skeleton tw-rounded-full"></div>
            </div>
        </div>
        <!-- Fake button -->
        <div class="tw-inline-flex tw-items-center tw-justify-end tw-col-span-1">
            <div class="tw-h-[33px] tw-w-[33px] tw-rounded-full tw-bg-ui-skeleton"></div>
        </div>
    </div>
</template>
<script setup>

</script>
